import { render } from "./ViewCallLogsAdmin.vue?vue&type=template&id=d9527d86&scoped=true"
import script from "./ViewCallLogsAdmin.vue?vue&type=script&lang=js"
export * from "./ViewCallLogsAdmin.vue?vue&type=script&lang=js"

import "./ViewCallLogsAdmin.vue?vue&type=style&index=0&id=d9527d86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9527d86"]])

export default __exports__